import React, {useState, useEffect} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import Input from "../forms/Input";
import Button from "../Button";
import _ from "lodash";
import ArchiveCustomerModal from "../../modals/ArchiveCustomerModal";

const CUSTOMER_DEFAULTS = {
    first_name:                 "",
    last_name:                  "",
    business_name:              "",
    account_number:             "",
    customer_type_id:           "",
    contact_telephone_number:   "",
    contact_mobile_number:      "",
    contact_email:              "",
    address_line_1:             "",
    address_line_2:             "",
    address_line_3:             "",
    town_city:                  "",
    state_county:               "",
    postcode_zipcode:           "",
    country:                    "United Kingdom",
    notes:                      "",
    enquiry_type:               "",
    enquiry_type_other:         "",
}

const CreateEditCustomer = (props) => {
    const {
        customerId  = null,
        onCancel    = () => {},
        onComplete  = () => {},
        onDelete    = () => {},
        parentId    = "",
    } = props;

    const [submitting, setSubmitting]                       = useState(false);
    const [customerTypes, setCustomerTypes]                 = useState([]);
    const [enquiryTypes, setEnquiryTypes]                   = useState([]);
    const [customer, setCustomer]                           = useState(CUSTOMER_DEFAULTS);
    const [errors, setErrors]                               = useState(null);
    const [archiveCustomerModal, setArchiveCustomerModal]   = useState(null);

    useEffect(() => {
        load();
    }, [customerId]);

    const load = () => {
        axios.get(route('web-api.customer.config', {customer_id: customerId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.customer_types) {
                        setCustomerTypes(response.data.customer_types);
                    }

                    if (!!response.data.enquiry_types) {
                        setEnquiryTypes(response.data.enquiry_types);
                    }

                    if (!!response.data.customer) {
                        setCustomer(response.data.customer);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const reset = () => {
        setCustomer(CUSTOMER_DEFAULTS);

        setSubmitting(false);
        setErrors(null);
    }

    const payload = () => {
        return {
            method: !!customerId ? 'patch' : 'post',
            url:    !!customerId ? route('web-api.customer.update', {customer: customerId}).toString() : route('web-api.customer.store').toString(),
            data:   customer,
        }
    }

    const submit = () => {
        axios(payload())
            .then((response) => {
                reset();
                onComplete(response.data.customer_id);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }

                setSubmitting(false);
            });
    }

    const handleClose = () => {
        if (!submitting) {
            reset();
            onCancel();
        }
    }

    const onChange = (field, value) => {
        const clone = _.cloneDeep(customer);

        clone[field] = value;

        setCustomer(clone);
    }

    return (
        <React.Fragment>
            <div className="row m-0 p-0">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"first_name"}
                        label={"First Name"}
                        required={!customer.last_name && !customer.business_name}
                        type={"text"}
                        value={customer.first_name}
                        disabled={submitting}
                        onChange={(value) => onChange("first_name", value)}
                        error={!!errors && !!errors.first_name ? errors.first_name : null}
                    />
                </div>
                <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                    <Input
                        name={"last_name"}
                        label={"Last Name"}
                        required={!customer.first_name && !customer.business_name}
                        type={"text"}
                        value={customer.last_name}
                        disabled={submitting}
                        onChange={(value) => onChange("last_name", value)}
                        error={!!errors && !!errors.last_name ? errors.last_name : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"business_name"}
                        label={"Business Name"}
                        required={!customer.first_name && !customer.last_name}
                        type={"text"}
                        value={customer.business_name}
                        disabled={submitting}
                        onChange={(value) => onChange("business_name", value)}
                        error={!!errors && !!errors.business_name ? errors.business_name : null}
                    />
                </div>
                <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                    <Input
                        name={"account_number"}
                        label={"Account Number"}
                        required={false}
                        type={"text"}
                        value={customer.account_number}
                        disabled={submitting}
                        onChange={(value) => onChange("account_number", value)}
                        error={!!errors && !!errors.account_number ? errors.account_number : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"customer_type_id"}
                        label={"Customer Type"}
                        required={true}
                        type={"select"}
                        options={customerTypes}
                        placeholder={"Select"}
                        value={customer.customer_type_id}
                        disabled={submitting}
                        onChange={(value) => onChange("customer_type_id", value)}
                        error={!!errors && !!errors.customer_type_id ? errors.customer_type_id : null}
                    />
                </div>
                <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                    <Input
                        name={"enquiry_type"}
                        label={"Enquiry Type"}
                        required={false}
                        type={"select"}
                        options={enquiryTypes}
                        placeholder={"Select"}
                        value={customer.enquiry_type}
                        disabled={submitting}
                        onChange={(value) => onChange("enquiry_type", value)}
                        error={!!errors && !!errors.enquiry_type ? errors.enquiry_type : null}
                    />
                </div>
            </div>
            {customer.enquiry_type === "Other" && (
                <div className="row m-0 mb-4 p-0">
                    <div className="col-12 m-0 p-0 bespoke-input">
                        <Input
                            name={"enquiry_type_other"}
                            label={"Other Details"}
                            required={customer.enquiry_type === "Other"}
                            type={"text"}
                            value={customer.enquiry_type_other}
                            disabled={submitting}
                            onChange={(value) => onChange("enquiry_type_other", value)}
                            error={!!errors && !!errors.enquiry_type_other ? errors.enquiry_type_other : null}
                        />
                    </div>
                </div>
            )}
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                <h2 className="h6 mb-0 text-eh-navy">Contact Information</h2>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"contact_telephone_number"}
                        label={"Telephone Number"}
                        required={false}
                        type={"text"}
                        value={customer.contact_telephone_number}
                        disabled={submitting}
                        onChange={(value) => onChange("contact_telephone_number", value)}
                        error={!!errors && !!errors.contact_telephone_number ? errors.contact_telephone_number : null}
                    />
                </div>
                <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                    <Input
                        name={"contact_mobile_number"}
                        label={"Mobile Number"}
                        required={false}
                        type={"text"}
                        value={customer.contact_mobile_number}
                        disabled={submitting}
                        onChange={(value) => onChange("contact_mobile_number", value)}
                        error={!!errors && !!errors.contact_mobile_number ? errors.contact_mobile_number : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0 mb-4">
                <div className="col-12 m-0 p-0 bespoke-input">
                    <Input
                        name={"contact_email"}
                        label={"Email"}
                        required={false}
                        type={"email"}
                        value={customer.contact_email}
                        disabled={submitting}
                        onChange={(value) => onChange("contact_email", value)}
                        error={!!errors && !!errors.contact_email ? errors.contact_email : null}
                    />
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                <h2 className="h6 mb-0 text-eh-navy">Main Address</h2>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"address_line_1"}
                        label={"Address Line 1"}
                        required={false}
                        type={"text"}
                        value={customer.address_line_1}
                        disabled={submitting}
                        onChange={(value) => onChange("address_line_1", value)}
                        error={!!errors && !!errors.address_line_1 ? errors.address_line_1 : null}
                    />
                </div>
                <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                    <Input
                        name={"address_line_2"}
                        label={"Address Line 2"}
                        required={false}
                        type={"text"}
                        value={customer.address_line_2}
                        disabled={submitting}
                        onChange={(value) => onChange("address_line_2", value)}
                        error={!!errors && !!errors.address_line_2 ? errors.address_line_2 : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"address_line_3"}
                        label={"Address Line 3"}
                        required={false}
                        type={"text"}
                        value={customer.address_line_3}
                        disabled={submitting}
                        onChange={(value) => onChange("address_line_3", value)}
                        error={!!errors && !!errors.address_line_3 ? errors.address_line_3 : null}
                    />
                </div>
                <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                    <Input
                        name={"town_city"}
                        label={"Town / City"}
                        required={false}
                        type={"text"}
                        value={customer.town_city}
                        disabled={submitting}
                        onChange={(value) => onChange("town_city", value)}
                        error={!!errors && !!errors.town_city ? errors.town_city : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"state_county"}
                        label={"County / State"}
                        required={false}
                        type={"text"}
                        value={customer.state_county}
                        disabled={submitting}
                        onChange={(value) => onChange("state_county", value)}
                        error={!!errors && !!errors.state_county ? errors.state_county : null}
                    />
                </div>
                <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                    <Input
                        name={"postcode_zipcode"}
                        label={"Postcode / Zipcode"}
                        required={false}
                        type={"postcode"}
                        value={customer.postcode_zipcode}
                        disabled={submitting}
                        onChange={(value) => onChange("postcode_zipcode", value)}
                        error={!!errors && !!errors.postcode_zipcode ? errors.postcode_zipcode : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0 mb-4">
                <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                    <Input
                        name={"country"}
                        label={"Country"}
                        required={false}
                        type={"text"}
                        value={customer.country}
                        disabled={submitting}
                        onChange={(value) => onChange("country", value)}
                        error={!!errors && !!errors.country ? errors.country : null}
                    />
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                <h2 className="h6 mb-0 text-eh-navy">Additional</h2>
            </div>
            <div className="row m-0 mb-4 p-0">
                <div className="col-12 m-0 p-0 bespoke-input">
                    <Input
                        name={"notes"}
                        label={"Notes"}
                        required={false}
                        type={"textarea"}
                        value={customer.notes}
                        disabled={submitting}
                        onChange={(value) => onChange("notes", value)}
                        error={!!errors && !!errors.notes ? errors.notes : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center">
                        <Button
                            onClick={() => setSubmitting(true)}
                            label={!!customerId ? "Save Changes" : "Create Customer"}
                            classes={"btn btn-eh-lilac m-0 mr-4"}
                        />
                        <Button
                            onClick={() => handleClose()}
                            label={"Cancel"}
                            classes={"btn btn-outline-eh-off-black m-0 mr-4"}
                        />
                    </div>
                    {!!customerId && !!customer && !!customer.can && customer.can.delete === true && (
                        <Button
                            onClick={() => setArchiveCustomerModal(customer)}
                            label={"Archive Customer"}
                            classes={"btn btn-danger m-0"}
                        />
                    )}
                </div>
            </div>
            <ArchiveCustomerModal
                show={!!archiveCustomerModal}
                customer={!!archiveCustomerModal ? archiveCustomerModal : null}
                parentId={parentId}
                onCancel={() => setArchiveCustomerModal(null)}
                onConfirm={() => onDelete()}
            />
        </React.Fragment>
    );
}

export default CreateEditCustomer;
